export class SynchedStateKeys {

	static exampleSynchedText = "SynchedStorage.exampleSynchedText"
	static synchedUser = "SynchedStorage.User"
	static synchedRole = "SynchedStorage.Role"

}